import axiosInstance from 'api/axiosInstance';

export const deleteRegisteredPlate = async (id: number): Promise<void> => {
	try {
		const API_URL = `/api2.0/registeredPlates/deleteRegisteredPlate`;
		await axiosInstance.post(
			API_URL,
			{ id },
			{
				headers: { 'Content-Type': 'application/json' },
			},
		);

		console.log(`✅ Registered plate with ID ${id} deleted successfully.`);
	} catch (error) {
		console.error(
			`❌ Error deleting registered plate with ID ${id}:`,
			error,
		);
		throw error;
	}
};
